export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const cellStyles = {
  verticalAlign: 'baseline',
  whiteSpace: 'unset',
};

export const bureausStyles = {
  fontWeight: 600,
  color: ({ palette }) => palette.text.primary,
};

export const descriptionCellStyles = {
  textAlign: 'center',

  '& .table-cell__content_box': {
    justifyContent: 'center',
  },
};

export const descriptionStyles = {
  fontStyle: 'italic',
};

export const keyFactorsItemStyles = {
  '& span': {
    fontWeight: 700,
  },
};
